import { gql } from '@apollo/client'

export default gql`
  query GetClaimableRewardTypeInfosByRewardName($name: [String!]) {
    getClaimableRewardTypeInfosByRewardName(name: $name) {
      staticAssetKey
      decimal
      network
      rewardType
      rewardName
      tokenErcType
      rewardTokenAddress
      rewardTokenID
    }
  }
`
